import { SxProps, Theme } from '@mui/material';

// eslint-disable-next-line import/prefer-default-export
export function mergeSx(...args: (SxProps<Theme> | undefined)[]): SxProps<Theme> {
	return args.map((sx) => (Array.isArray(sx) ? sx : [sx].filter(Boolean))).flat();
}
